import { DefaultTheme } from 'styled-components';
import {
  CONSIGNMENT_STATUS,
  DASHBOARD_CARD_TYPE,
  RETURN_STATUS,
  SYSTEM_COLORS,
} from 'themes/common';

export const dark: DefaultTheme = {
  theme: 'dark',
  ...CONSIGNMENT_STATUS,
  ...DASHBOARD_CARD_TYPE,
  ...RETURN_STATUS,
  ...SYSTEM_COLORS,
};
